import { Pipe, PipeTransform } from '@angular/core'
import { parseISO, isValid, format } from 'date-fns'

@Pipe({
    name: 'formatISODateCzech',
    standalone: false
})
export class FormatIsoDateCzechPipe implements PipeTransform {

    transform(date: string): string {
        const parsedDate = parseISO(date)

        return isValid(parsedDate) ?  format(parsedDate, 'd.M.yyyy') : ''
    }
}